import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Bodies() {
	return (
		<g>
			<path className="fill fill--alt leg leg--left" fill="#F9CA8C" d="M295.65915,322.78326
				c-2.06384-16.52185-11.40875-32.41916-30.38394-35.14792c-18.9749-2.72906-35.93547,13.94757-38.66423,32.92273
				c-0.44888,3.12186-0.61162,6.33524-0.49562,9.51727l-6.49878,0.70261c-9.27345,1.00223-15.67355,9.66104-14.67134,18.93451
				c1.00223,9.27344,10.76855,13.90826,20.04201,12.90631l25.54213-2.76038
				C280.31625,356.63898,298.98688,349.42218,295.65915,322.78326z" />
			<g className="tail">
				<circle className="fill fill--white" fill="#FFFFFF" cx="343.8403" cy="332.86063" r="24.02028" />
			</g>
			<path className="fill belly" fill="#FAD59E" d="M342.37531,336.51498c-6.95691,31.88583-28.17328,33.68982-62.52521,33.63113
				c-27.80345-0.04745-86.24832-24.34467-86.24832-58.33105s7.07106-45.30084,69.52274-59.92542
				C318.52808,238.91556,351.33084,295.46881,342.37531,336.51498z" />
			<path className="fill fill--alt arm arm--right" fill="#F9CA8C" d="M223.75703,382.52258c-9.32733,0-16.88881-5.30783-16.88881-14.63516
				v-25.69113c0-9.32733,7.56148-16.88882,16.88881-16.88882s16.88882,7.56149,16.88882,16.88882v25.69113
				C240.64586,377.21475,233.08437,382.52258,223.75703,382.52258z" />
			<path className="fill fill--alt arm arm--left" fill="#F9CA8C" d="M184.18922,382.52258c-9.32733,0-16.88882-5.30783-16.88882-14.63516
				v-25.69113c0-9.32733,7.56149-16.88882,16.88882-16.88882s16.88881,7.56149,16.88881,16.88882v25.69113
				C201.07803,377.21475,193.51656,382.52258,184.18922,382.52258z" />
			<path className="fill torso" fill="#FAD59E" d="M250.82784,316.36142c-0.64923,24.89731-21.77948,41.16284-47.19939,40.49997
				c-25.41989-0.66284-45.50343-18.00308-44.8542-42.90036c0.64923-24.89731,21.78244-46.79688,47.20233-46.134
				C231.39647,268.48987,251.47707,291.46411,250.82784,316.36142z" />
			<path className="fill fill--alt leg leg--right" fill="#F9CA8C" d="M345.27444,340.06955
				c-2.06384-16.52185-11.40875-32.41916-30.38394-35.14792s-35.93546,13.94785-38.66449,32.92276
				c-0.44888,3.12183-0.61163,6.33521-0.49536,9.51755l-6.49905,0.70233c-9.27319,1.0022-15.67328,9.66132-14.67134,18.93448
				c1.00223,9.27347,10.76854,13.90854,20.04201,12.90631l25.54242-2.76038
				C329.93155,373.92554,348.60217,366.70874,345.27444,340.06955z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Bunny/Bodies.js